export const config = {
	is_mixpanel_enabled: typeof process.env.VUE_APP_MIX_PANEL_KEY === 'undefined'
};